import axios from 'axios'; // eslint-disable-line no-restricted-imports -- TODO remove axios
import { getAuthenticityToken } from '~/utilities/getAuthenticityToken';

const logEvent = (type, { action, hashedId, id }) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getAuthenticityToken();
  return axios.post(`/data/event/${type}`, {
    /* eslint-disable-next-line camelcase */
    event_action: action,
    hashed_id: hashedId,
    id,
  });
};

export const logProjectEvent = (params) => logEvent('project', params);

export const logMediaEvent = (params) => logEvent('media', params);
